import React from "react";
import { connect } from "react-redux";
import { Content } from "../../pages/Template";
import AdminPage from "../../admin/AdminPage";
import { Featured } from "../../models";
import { Results, Book } from "../../components";
import FeaturedMark from "./FeaturedMark";
import { AppState } from "../../store";
import { AxiosResponse } from "axios";
import { ReaderDoc } from "../../components/Reader/PageContents/index";

function isFeatured(id: number, featured: Record<number, number>) {
    return typeof featured[id] !== "undefined";
}

const mapState = ({ user }: AppState) => ({ user });
type StateProps = ReturnType<typeof mapState>;
type Props = StateProps & {};
type List = Array<ReaderDoc>;
type Stats = {
    offset: number;
    limit: number;
    total: number;
};
type State = {
    featured: Record<number, number>;
    list: List;
    stats: Stats;
};

class FeaturedAdminPage extends AdminPage<Props, State> {
    static paths = ["/app/a/featured"];

    constructor(props: Props) {
        super(props);
        this.state = {
            featured: {},
            list: [],
            stats: {
                offset: 0,
                limit: 0,
                total: 0,
            },
        };
    }

    async componentDidMount() {
        await this.fetch();
        await this.fetchFeatured();
    }

    async componentWillReceiveProps(_nextProps: Props, _nextContext: any) {
        await this.fetch();
    }

    loading = false;
    async fetch(concat = false) {
        if (this.loading) {
            return;
        }
        this.loading = true;

        try {
            const {
                stats: { offset, limit },
            } = this.state;
            const params = [
                "includeMeta=true",
                `offset=${concat ? offset + limit : 0}`,
            ];

            const {
                data: { list, stats },
            }: AxiosResponse<{
                list: List;
                stats: Stats;
            }> = await Featured.list({
                url: params.join("&"),
            });

            this.setState({
                stats,
                list: concat ? this.state.list.concat(list) : list,
            });
            this.loading = false;
        } catch (e) {
            console.warn(e);
        }
    }

    loadingFeatured = false;
    async fetchFeatured() {
        if (this.loadingFeatured) {
            return;
        }
        this.loadingFeatured = true;

        const {
            data,
        }: AxiosResponse<
            Array<{
                id: number;
                doc_id: number;
                weight: number;
            }>
        > = await Featured.fetch("doc_ids");
        const featured: Record<number, number> = {};
        data.forEach((v) => (featured[v.doc_id] = v.weight));
        this.setState({ featured });

        this.loadingFeatured = false;
    }

    onMore = async () => {
        await this.fetch(true);
    };

    onClick = async ({ id }: { id: number }) => {
        if (isFeatured(id, this.state.featured)) {
            await Featured.destroy(id);
        } else {
            await Featured.save({ doc_id: id }, "");
        }
        await this.fetchFeatured();
    };

    onWeightChange = async (doc_id: number, weight: number) => {
        const { featured } = this.state;
        if (featured[doc_id] !== weight) {
            featured[doc_id] = weight;
            this.setState({ featured: { ...featured } });
            await Featured.save({ doc_id, weight }, "weight");
        }
    };

    render() {
        const { featured, list, stats } = this.state;
        if (list.length === 0) {
            return null;
        }

        return (
            <Content>
                <Results stats={stats} onMore={this.onMore}>
                    {list.map((item) => (
                        <Book
                            {...item}
                            width={160}
                            key={`book-${item.id}`}
                            onClick={() => this.onClick(item)}
                        >
                            {isFeatured(item.id, featured) ? (
                                <FeaturedMark
                                    doc_id={item.id}
                                    weight={featured[item.id]}
                                    onWeightChange={this.onWeightChange}
                                />
                            ) : undefined}
                        </Book>
                    ))}
                </Results>
            </Content>
        );
    }
}

export default connect(mapState)(FeaturedAdminPage);
